import _ from 'lodash';

const emptyResult = { contactId: '', serviceCase: {} };

const isServiceCaseCollection = (contactCases) => (
  Array.isArray(contactCases) || Array.isArray(contactCases?.data)
);

const sortContactEntries = ([leftContactId], [rightContactId]) => {
  if (!leftContactId && rightContactId) return 1;
  if (leftContactId && !rightContactId) return -1;
  return 0;
};

const getSearchableEntries = (serviceCaseState) => (
  Object.entries(serviceCaseState)
    .filter(([, contactCases]) => isServiceCaseCollection(contactCases))
    .sort(sortContactEntries)
);

const getServiceCaseMatch = ([contactId, contactCases], caseId) => {
  const currentContactCases = contactCases?.data || contactCases;
  const serviceCase = _.find(currentContactCases, (currentCase) => currentCase.id === caseId);

  return serviceCase ? { contactId, serviceCase } : null;
};

export default function findServiceCaseById(serviceCaseState = {}, caseId = '') {
  if (!caseId) {
    return emptyResult;
  }

  return getSearchableEntries(serviceCaseState)
    .map((entry) => getServiceCaseMatch(entry, caseId))
    .find(Boolean) || emptyResult;
}
